import {
  Alert,
  Checkbox,
  FormControlLabel,
  TextField,
} from "@mui/material";
import React, { useState, useEffect, useRef } from "react";
import {
  Accordion,
  Button,
  Card,
  Col,
  Form,
  Row,
  Spinner,
  Tab,
  Tabs,
} from "react-bootstrap";
import { Controller, useForm } from "react-hook-form";
import ApiBasketItemPerson from "../../../core/api/api.basketItemPerson";
import SwalMessage from "../../pages/_Components/SwalMessage";
import _ from "lodash";
import Swal from "sweetalert2";
import { tools } from "../../../core/utils/tools";
import LoaderDot from "../_Components/LoaderDot";
import TicketStatusToUsedResultModal from "./Component/TicketStatusToUsedResultModal";
import TickeInfoBox from "./Component/TickeInfoBox";

import {
  IconMobile,
  IconNoTicket,
  IconTicket1,
  IconUser,
  IconTicket,
} from "../../../_metronic/css/icons";
function TicketList() {
  const [tickets, setTickets] = useState([]);
  const [searchTickets, setSearchTickets] = useState();
  const [ticketNumber, setTicketNumber] = useState();
  const [searchTextDisplay, setSearchTextDisplay] = useState();
  const [loadingLastTicket, setLoadingLastTicket] = useState(true);
  const [loadingSearch, setLoadingSearch] = useState(false);
  const [tabKey, setTabKey] = useState("used");
  const [displaySearchResult, setDisplaySearchResult] = useState(false);
  const cancelButtonRef = useRef(null); // ایجاد ref برای دکمه "ابطال بلیط"
  const textFieldRef = useRef(null);

  const {
    control,
    handleSubmit,
    formState: { isSubmitting, errors },
    setValue,
    clearErrors,
  } = useForm();
  const fetchAllTickets = async () => {
    setLoadingLastTicket(true);
    try {
      const response = await ApiBasketItemPerson.getAllTicket();
      setTickets(response.data);
    } catch (error) {
      setLoadingLastTicket(false);
    } finally {
      setLoadingLastTicket(false);
    }
  };
  useEffect(() => {
    (async () => {
      fetchAllTickets();
    })();
    return () => { };
  }, []);

  useEffect(() => {
    textFieldRef.current.focus(); // فوکوس کردن
  }, []);

  useEffect(() => {
    if (displaySearchResult && searchTickets && cancelButtonRef.current) {
      setTimeout(() => {
        cancelButtonRef.current.focus(); // فوکوس کردن
      }, 100);
    }
  }, [displaySearchResult, searchTickets]);

  const fetchTickets = async () => {
    try {
      const response = await ApiBasketItemPerson.getTicketById(ticketNumber);
      setSearchTickets(response.data);
      if (cancelButtonRef.current) {
        cancelButtonRef.current.focus(); // فوکوس به دکمه "ابطال بلیط"
      }
    } catch (error) {
    }
  };
  const onSubmit = async (data) => {
    if (_.isEmpty(data.ticketNumber)) {
      SwalMessage({
        title: "لطفا شماره بلیط مورد نظر را انتخاب نمایید",
        iSsuccess: false,
      });
      return;
    }
    setLoadingSearch(true);
    setTicketNumber(data.ticketNumber);
    const response = await ApiBasketItemPerson.getTicketById(data.ticketNumber);
    if (response?.data?.basketId == 0) {
      setSearchTextDisplay(true);
      setLoadingSearch(false);
    } else {
      setSearchTextDisplay(false);
      setLoadingSearch(false);
      setSearchTickets(response.data);
      setDisplaySearchResult(true);
      fetchAllTickets();
    }
  };
  // تابعی برای پاک کردن و فوکوس روی TextField
  const resetAndFocusTextField = () => {
    setDisplaySearchResult(false);
    setSearchTickets(null);

    setValue("ticketNumber", "");
    setTimeout(() => {
      textFieldRef.current.focus(); // فوکوس کردن
    }, 100);
  };

  /** قسمت ابطال بلیط ******************/
  const initialCount = searchTickets?.basketItemPersons?.length || 0;
  useEffect(() => {
    if (searchTickets?.basketItemPersons) {
      setSelectedCount(initialCount);
      // مقداردهی اولیه checkedStatus به طول tickets.basketItemPersons
      setCheckedStatus(
        new Array(searchTickets.basketItemPersons.length).fill(true)
      );
    }
  }, [searchTickets]);

  const [selectedCount, setSelectedCount] = useState(initialCount);
  const [checkedStatus, setCheckedStatus] = useState([]);
  const [loadingBtn, setLoadingBtn] = useState(false);
  // const bookedTicketCount =
  //     tickets.length > 0 && tickets.filter((item) => item.bookedTicketCount > 0); // آماده استفاده
  // const invalidTicketCount =
  //     tickets.length > 0 && tickets.filter((item) => item.invalidTicketCount > 0); // استفاده شده
  // const cancelledTicketCount =
  //     tickets.length > 0 &&
  //     tickets.filter((item) => item.cancelledTicketCount > 0); // استرداد
  const handleSelectChange = (e) => {
    const newCount = Number(e.target.value);
    setSelectedCount(newCount);
    // به‌روزرسانی وضعیت چک‌باکس‌ها بر اساس مقدار انتخابی
    const newCheckedStatus = checkedStatus.map((_, index) => index < newCount);
    setCheckedStatus(newCheckedStatus);
  };
  const handleCheckboxChange = (index) => {
    const updatedStatus = [...checkedStatus];
    updatedStatus[index] = !updatedStatus[index];

    // به‌روزرسانی تعداد انتخاب‌شده
    setCheckedStatus(updatedStatus);
    setSelectedCount(updatedStatus.filter(Boolean).length);
  };

  const handleCancel = () => {
    //setShowComponent(false); // مخفی کردن کامپوننت
    setSearchTickets(null);
    setDisplaySearchResult(false);
    setTimeout(() => {
      textFieldRef.current.focus(); // فوکوس کردن
    }, 100);
  };
  const [updatedTicket, setUpdatedTicket] = useState();
  const [
    showModalTicketStatusToUsedResult,
    setShowModalTicketStatusToUsedResult,
  ] = useState(false);

  const cancelTicket = async () => {
    const checkedTickets = searchTickets?.basketItemPersons?.filter(
      (_, index) => checkedStatus[index]
    );
    const ticketIds = checkedTickets.map((ticket) => ticket.id);

    const payload = { Tickets: ticketIds };
    setLoadingBtn(true);

    try {
      const response = await ApiBasketItemPerson.cancelTickets(payload);
      if (response.succeeded) {
        const response2 = await ApiBasketItemPerson.getUsedTicketsByIds(
          payload?.Tickets
        );
        setUpdatedTicket(response2.data);
        setShowModalTicketStatusToUsedResult(true);
      } else {
        SwalMessage({
          title: response.message,
          iSsuccess: response.succeeded,
        });
        setShowModalTicketStatusToUsedResult(false);
        fetchTickets();
      }
    } catch (error) {
      fetchTickets();
    } finally {
      setLoadingBtn(false);
    }
  };

  const handleCancelTickets = () => {
    const shamsiDate = tools.getShamsiDateIntlEnglishNumbers();
    const checkInDate = searchTickets.basketItemPersons[0]?.checkInDate;
    if (shamsiDate !== checkInDate) {
      Swal.fire({
        title: "عدم تطابق تاریخ",
        text: "تاریخ بلیط انتخاب شده برای روز جاری نمی باشد. آیا از ابطال آن مطمئن هستید؟",
        icon: "warning",
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: "بله ابطال گردد",
        cancelButtonText: "انصراف",
        customClass: {
          confirmButton: "btn btn-danger mx-2",
          cancelButton: "btn btn-secondary",
        },
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.isConfirmed) {
          cancelTicket();
        }
      });
    } else {
      cancelTicket();
    }
  };
  //    جلوگیری از وارد کردن حروف و فقط اجازه دادن به اعداد فارسی و انگلیسی
  const handleKeyPress = (e) => {
    const regex = /^[0-9۰-۹]$/;
    if (!regex.test(e.key)) {
      e.preventDefault();
    }
  };

  // تابع برای تبدیل عدد فارسی به انگلیسی
  const convertToEnglishNumber = (input) => {
    const persianToEnglish = {
      "۰": "0",
      "۱": "1",
      "۲": "2",
      "۳": "3",
      "۴": "4",
      "۵": "5",
      "۶": "6",
      "۷": "7",
      "۸": "8",
      "۹": "9",
    };

    return input.replace(/[۰-۹]/g, (char) => persianToEnglish[char] || char);
  };
  //    ارسال فرم با فشردن اینتر
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSubmit(onSubmit)();
    }
  };
  const handleClearTicketNumber = () => {
    setValue("ticketNumber", ""); // پاک کردن فیلد شماره بلیط
    clearErrors("ticketNumber");
    setSearchTextDisplay(); // مخفی کردن پیام شماره بلیط معتبر نمی باشد
    if (textFieldRef.current) {
      textFieldRef.current.focus();
    }
  };
  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="pb-3">
          <Card>
            <Card.Body className="py-3 px-5">
              <Row>
                <Col className="pr-0">
                  <Controller
                    name="ticketNumber"
                    control={control}
                    rules={{
                      required: true,
                      pattern: {
                        value: /^[0-9۰-۹]+$/,
                        message: "لطفا فقط عدد وارد کنید",
                      },
                      maxLength: {
                        value: 10,
                        message: "حداکثر تعداد ارقام 10 است",
                      },
                      validate: (value) => {
                        const numValue = convertToEnglishNumber(value);
                        const numericValue = parseInt(numValue, 10);
                        return (
                          (!isNaN(numericValue) &&
                            numericValue <= 2147483647) ||
                          "شماره بلیط باید یک عدد صحیح و کمتر از 2,147,483,647 باشد"
                        );
                      },
                    }}
                    render={({ field: { onChange, value } }) => (
                      <TextField
                        label="جستجو شماره بلیط"
                        margin="normal"
                        variant="outlined"
                        size="small"
                        value={value || ""}
                        style={{ height: "23px" }}
                        error={!!errors.ticketNumber}
                        onChange={(e) => {
                          const englishValue = convertToEnglishNumber(
                            e.target.value
                          );
                          onChange(englishValue);
                          if (englishValue === "") {
                            setSearchTextDisplay();
                          }
                        }}
                        inputProps={{
                          maxLength: 10,
                          onKeyPress: handleKeyPress,
                          onKeyDown: handleKeyDown,
                        }}
                        inputRef={textFieldRef}
                      />
                    )}
                  />
                  <div className="text-danger my-3 fs-small">
                    {errors.ticketNumber?.message}
                  </div>
                </Col>
                <Col xs="auto" className="pl-2 pr-2">
                  {loadingSearch ? (
                    <Button
                      variant="primary"
                      type="submit"
                      style={{ marginTop: "16px", height: "35px" }}
                      disabled
                    >
                      <i className="fas fa-search p-0"></i>
                    </Button>
                  ) : (
                    <Button
                      variant="primary"
                      style={{ marginTop: "16px", height: "35px" }}
                      type="submit"
                    >
                      <i className="fas fa-search p-0"></i>
                    </Button>
                  )}
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </div>
      </form>
      {loadingSearch ? (
        <div className=" bg-white border rounded-3 p-5 shadow-sm mx-auto">
          <LoaderDot text="در حال جستجوی بلیط" />
        </div>
      ) : (
        ""
      )}
      {searchTextDisplay === true ? (
        <Alert
          severity="warning"
          className="rounded-3 my-3 border text-center py-3 align-items-center justify-content-center"
          style={{ fontSize: "14px" }}
        >
          شماره بلیط معتبر نمی باشد!
        </Alert>
      ) : searchTextDisplay === false ? (
        <>
          {showModalTicketStatusToUsedResult && (
            <TicketStatusToUsedResultModal
              showModalTicketStatusToUsedResult={
                showModalTicketStatusToUsedResult
              }
              setShowModalTicketStatusToUsedResult={
                setShowModalTicketStatusToUsedResult
              }
              updatedTicket={updatedTicket}
              setTickets={setTickets}
              onResetAndFocus={resetAndFocusTextField}
              fetchAllTickets={fetchAllTickets}
            />
          )}

          {searchTickets?.basketId > 0 && displaySearchResult && (
            <Card className="rounded-4  border border-secondary">
              <Card.Header className="rounded-top-4 p-4 text-dark-primary bg-light">
                <div className="d-flex justify-content-between  justify-content-sm-start fw-bold acc">
                  <div>
                    <span className="small-svg mr-1">
                      <IconUser />
                    </span>
                    <span>{searchTickets.basketUser} </span>
                  </div>
                  <div className=" ml-sm-5">
                    <span>{searchTickets.userMobile}</span>

                    <span className="small-svg mr-1 d-sm-none">
                      <IconMobile />
                    </span>
                  </div>
                </div>
              </Card.Header>
              <Card.Body className="acc p-3">
                <div className="d-flex justify-content-between ">
                  <div>
                    <Row className="text-green">
                      <Col
                        xs="12"
                        sm
                        className="nowrap text-center my-auto fs-small-1"
                      >
                        <span className="small-svg mr-1">
                          <IconTicket1 />
                        </span>
                        آماده استفاده{" "}
                      </Col>
                      <Col
                        xs="12"
                        sm
                        className="nowrap mt-3 mt-sm-0 text-center"
                      >
                        <div className="bg-green py-1 rounded-2 mx-3 mx-sm-2">
                          <span className="fw-bold mx-1">
                            {searchTickets.bookedTicketCount}
                          </span>{" "}
                          بلیط
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row className="text-red">
                      <Col
                        xs="12"
                        sm
                        className="nowrap text-center my-auto fs-small-1"
                      >
                        <span className="small-svg mr-1">
                          <IconTicket />
                        </span>
                        استفاده شده
                      </Col>
                      <Col
                        xs="12"
                        sm
                        className="nowrap mt-3 mt-sm-0 text-center"
                      >
                        <div className="bg-red py-1 rounded-2 mx-3 mx-sm-2">
                          <span className="fw-bold mx-1">
                            {" "}
                            {searchTickets.invalidTicketCount}
                          </span>{" "}
                          بلیط
                        </div>
                      </Col>
                    </Row>
                  </div>
                  <div>
                    <Row className="text-orange">
                      <Col
                        xs="12"
                        sm
                        className="nowrap text-center my-auto fs-small-1"
                      >
                        <span className="small-svg mr-1">
                          <IconNoTicket />
                        </span>
                        کنسل شده
                      </Col>
                      <Col
                        xs="12"
                        sm
                        className="nowrap mt-3 mt-sm-0 text-center"
                      >
                        <div className="bg-orange py-1 rounded-2 mx-3 mx-sm-0">
                          <span className="fw-bold mx-1">
                            {searchTickets.cancelledTicketCount}
                          </span>{" "}
                          بلیط
                        </div>
                      </Col>
                    </Row>
                  </div>
                </div>
                <div className="border-top mt-4 pt-4 px-3">
                  <Row>
                    <Col xs="auto" className="pr-0">
                      <Form.Select
                        className="text-center"
                        style={{ width: "60px" }}
                        value={selectedCount}
                        onChange={handleSelectChange}
                      >
                        <option key={0} value={0}>
                          {0}
                        </option>
                        {/* Render options dynamically based on the number of persons */}
                        {searchTickets?.basketItemPersons?.map((_, index) => (
                          <option key={index} value={index + 1}>
                            {index + 1}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                    {searchTickets.basketItemPersons?.length ? (
                      <Col xs className="pl-2 my-auto">
                        <div>
                          عدد بلیط جهت استفاده در تاریخ{" "}
                          {`${searchTickets.basketItemPersons[0].checkInDate}`}{" "}
                        </div>
                      </Col>
                    ) : (
                      ""
                    )}
                  </Row>
                  <Row className="mt-3">
                    {searchTickets?.basketItemPersons?.map((ticket, index) => (
                      <Col key={ticket.id} xs="auto" className="px-2">
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={checkedStatus[index] || false} // استفاده از مقدار پیش‌فرض false اگر undefined بود
                              onChange={() => handleCheckboxChange(index)}
                              color="primary"
                            />
                          }
                          label={ticket.id}
                        />
                      </Col>
                    ))}
                  </Row>

                  <Row className="mt-3 pb-2">
                    <Col xs="auto" className="pr-0">
                      {loadingBtn ? (
                        <Button
                          variant="danger"
                          className="px-5 py-2"
                          onClick={handleCancelTickets}
                          ref={cancelButtonRef}
                          //ref={ref} // اینجا ref به Button منتقل می‌شود
                          disabled
                        >
                          <Spinner size="sm" />
                          ابطال بلیط
                        </Button>
                      ) : (
                        <Button
                          variant="danger"
                          className="px-5 py-2 pulse-btn"
                          onClick={handleCancelTickets}
                          ref={cancelButtonRef}
                          //ref={ref} // اینجا ref به Button منتقل می‌شود
                          disabled={selectedCount === 0}
                        >
                          ابطال بلیط
                        </Button>
                      )}
                    </Col>
                    <Col xs="auto" className="pl-2">
                      <Button
                        variant="outline-danger"
                        className="px-4 py-2 "
                        onClick={handleCancel}
                      >
                        انصراف
                      </Button>
                    </Col>
                  </Row>
                </div>
              </Card.Body>
            </Card>
          )}
        </>
      ) : (
        ""
      )}
      {/* <hr className="border-dark" /> */}
      <div className="pt-5"></div>
      <Card className="mb-3">
        <Card.Body className="p-3">
          <div
            className="d-flex align-items-center"
            style={{ fontSize: "11px" }}
          >
            <div>راهنما:</div>

            <div className="text-green d-flex align-items-center me-2">
              <div
                className=" bg-green rounded-4 mx-1"
                style={{ width: "10px", height: "10px" }}
              ></div>
              آماده استفاده
            </div>
            <div className="text-green d-flex align-items-center me-2">
              <div className="text-red mx-1 d-flex align-items-center">
                <div
                  className=" bg-red rounded-4 mx-1"
                  style={{ width: "10px", height: "10px" }}
                ></div>{" "}
                استفاده شده
              </div>
            </div>
            <div>
              <Button
                variant="secondary me-2 d-flex align-items-center"
                className="py-1"
                style={{ fontSize: "11px" }}
              >
                <i
                  className="fas fa-video opacity-25"
                  style={{ fontSize: "11px" }}
                ></i>{" "}
                آموزش
              </Button>
            </div>
          </div>
        </Card.Body>
      </Card>
      <Card>
        <Card.Body className="py-3 px-3">
          <Tabs
            id="showTab"
            activeKey={tabKey}
            onSelect={(k) => setTabKey(k)}
            className="mb-3"
          >
            {/* <Tab eventKey="reserved" title="آماده استفاده">
              {loadingLastTicket ? (
                <LoaderDot text="در حال دریافت اطلاعات" />
              ) : (
                <div>
                  <Accordion className="acc" defaultActiveKey={["0"]} flush>
                    {tickets?.filter((item) => item.bookedTicketCount > 0)
                      ?.length > 0 ? (
                      tickets
                        ?.filter((item) => item.bookedTicketCount > 0)
                        ?.map((item, index) => (
                          <Accordion.Item
                            eventKey={index.toString()}
                            key={index}
                            className="mb-2 rounded-3 border"
                          >
                            <TickeInfoBox item={item} />
                          </Accordion.Item>
                        ))
                    ) : (
                      <Alert severity="warning" className=" ">
                        بلیطی وجود ندارد.
                      </Alert>
                    )}
                  </Accordion>
                </div>
              )}{" "}
            </Tab> */}
            <Tab eventKey="used" title="استفاده شده">
              {loadingLastTicket ? (
                <LoaderDot text="در حال دریافت اطلاعات" />
              ) : (
                <div>
                  <Accordion className="acc" defaultActiveKey={["0"]} flush>
                    {tickets?.filter((item) => item.invalidTicketCount > 0)
                      ?.length > 0 ? (
                      tickets
                        ?.filter((item) => item.invalidTicketCount > 0)
                        ?.map((item, index) => (
                          <Accordion.Item
                            eventKey={index.toString()}
                            key={index}
                            className="mb-2 rounded-3 border"
                          >
                            <TickeInfoBox item={item} />
                          </Accordion.Item>
                        ))
                    ) : (
                      <Alert severity="warning" className=" ">
                        بلیطی وجود ندارد.
                      </Alert>
                    )}
                  </Accordion>
                </div>
              )}{" "}
            </Tab>
            <Tab eventKey="refund" title="استرداد">
              {loadingLastTicket ? (
                <LoaderDot text="در حال دریافت اطلاعات" />
              ) : (
                <div>
                  <Accordion className="acc" defaultActiveKey={["0"]} flush>
                    {tickets?.filter((item) => item.cancelledTicketCount > 0)
                      ?.length > 0 ? (
                      tickets
                        ?.filter((item) => item.cancelledTicketCount > 0)
                        ?.map((item, index) => (
                          <Accordion.Item
                            eventKey={index.toString()}
                            key={index}
                            className="mb-2 rounded-3 border"
                          >
                            <TickeInfoBox item={item} />
                          </Accordion.Item>
                        ))
                    ) : (
                      <Alert severity="warning" className=" ">
                        بلیطی وجود ندارد.
                      </Alert>
                    )}
                  </Accordion>
                </div>
              )}{" "}
            </Tab>
          </Tabs>
        </Card.Body>
      </Card>
    </>
  );
}
export default TicketList;
